export default {"src":"/_next/static/media/arrow_up.ef5be4de.svg","height":10,"width":19,"blurWidth":0,"blurHeight":0};